import LabeledField from '@components/common/form/formik/input/LabeledField';
import React from 'react';

const GradeInfo: React.FC = () => {
  return (
    <>
      <LabeledField label='Minimum Grade' name='gradeInfo.regular.min' type='number' />
      <LabeledField label='Maximum Grade' name='gradeInfo.regular.max' type='number' />
      <LabeledField
        label='Minimum Grade (Exception)'
        name='gradeInfo.exception.min'
        type='number'
      />
      <LabeledField
        label='Maximum Grade (Exception)'
        name='gradeInfo.exception.max'
        type='number'
      />
    </>
  );
};

export default GradeInfo;
